/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentSettings
 */
export interface PaymentSettings {
    /**
     * 
     * @type {boolean}
     * @memberof PaymentSettings
     */
    isInvoiceBeforePayment: boolean;
    /**
     * 
     * @type {string}
     * @memberof PaymentSettings
     */
    platformSubsidiaryId: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentSettings
     */
    paymentTermInDays?: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentSettings
     */
    contractReference?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentSettings
     */
    applyEndOfMonthRule?: boolean;
}

/**
 * Check if a given object implements the PaymentSettings interface.
 */
export function instanceOfPaymentSettings(value: object): value is PaymentSettings {
    if (!('isInvoiceBeforePayment' in value) || value['isInvoiceBeforePayment'] === undefined) return false;
    if (!('platformSubsidiaryId' in value) || value['platformSubsidiaryId'] === undefined) return false;
    return true;
}

export function PaymentSettingsFromJSON(json: any): PaymentSettings {
    return PaymentSettingsFromJSONTyped(json, false);
}

export function PaymentSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'isInvoiceBeforePayment': json['isInvoiceBeforePayment'],
        'platformSubsidiaryId': json['platformSubsidiaryId'],
        'paymentTermInDays': json['paymentTermInDays'] == null ? undefined : json['paymentTermInDays'],
        'contractReference': json['contractReference'] == null ? undefined : json['contractReference'],
        'applyEndOfMonthRule': json['applyEndOfMonthRule'] == null ? undefined : json['applyEndOfMonthRule'],
    };
}

export function PaymentSettingsToJSON(value?: PaymentSettings | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'isInvoiceBeforePayment': value['isInvoiceBeforePayment'],
        'platformSubsidiaryId': value['platformSubsidiaryId'],
        'paymentTermInDays': value['paymentTermInDays'],
        'contractReference': value['contractReference'],
        'applyEndOfMonthRule': value['applyEndOfMonthRule'],
    };
}

